export default __webpack_public_path__ + "static/palmprint-96f756b46c1c1b9750f013a6b7ebe9d4.png";